import React from "react";
import { MapPin, Phone, Mail, Facebook, Instagram } from "lucide-react";
import WashSofaLogo from "./WashSofaLogo";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - 72;
    window.scrollTo({ top, behavior: "smooth" });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};

const NAV_LINKS = [
{ id: "hero", label: "Home" },
{ id: "servizi", label: "Servizi" },
{ id: "tecnologia", label: "Tecnologia" },
{ id: "ecosostenibilita", label: "Ecosostenibilità" },
{ id: "contatti", label: "Contatti" }];


export default function Footer() {
  return (
    <footer className="footer">
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "3.5rem 2rem 2rem 2rem"
        }}>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "2.5rem",
            marginBottom: "3rem"
          }}>

          {/* Logo & descrizione */}
          <div>
            <WashSofaLogo white size="md" />
            <p
              style={{
                color: "rgba(255,255,255,0.65)",
                fontSize: "0.9rem",
                marginTop: "1rem",
                lineHeight: 1.7,
                maxWidth: "280px"
              }}>

              Servizio professionale di pulizia e sanificazione di divani,
              materassi e tessuti. Metodo senz'acqua, ecologico e sicuro.
              <br />
              <span style={{ opacity: 0.6, fontSize: "0.82rem" }}>
                P.IVA 01263280578
              </span>
            </p>
            <div style={{ display: "flex", gap: "1rem", marginTop: "1.2rem" }}>
              <a
                href="https://www.facebook.com/profile.php?id=61581011145754"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: "36px", height: "36px",
                  background: "rgba(255,255,255,0.1)",
                  borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  transition: "background 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "#17C3CE"}
                onMouseLeave={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}>

                <Facebook size={17} color="white" />
              </a>
              <a
                href="https://www.instagram.com/divano__pulito/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: "36px", height: "36px",
                  background: "rgba(255,255,255,0.1)",
                  borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  transition: "background 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "#17C3CE"}
                onMouseLeave={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}>

                <Instagram size={17} color="white" />
              </a>
            </div>
          </div>

          {/* Navigazione */}
          <div>
            <h4 style={{
              color: "white", fontWeight: 600, marginBottom: "1.2rem",
              textTransform: "uppercase", letterSpacing: "0.06em", fontSize: "0.8rem"
            }}>
              NAVIGAZIONE
            </h4>
            {NAV_LINKS.map((link) =>
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              style={{
                display: "block",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "rgba(255,255,255,0.7)",
                fontSize: "0.9rem",
                marginBottom: "0.6rem",
                padding: 0,
                textAlign: "left",
                transition: "color 0.2s ease",
                fontFamily: "inherit"
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = "#17C3CE"}
              onMouseLeave={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.7)"}>

                {link.label}
              </button>
            )}
          </div>

          {/* Sede */}
          <div>
            <h4 style={{
              color: "white", fontWeight: 600, marginBottom: "1.2rem",
              textTransform: "uppercase", letterSpacing: "0.06em", fontSize: "0.8rem"
            }}>
              SEDE
            </h4>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "0.6rem" }}>
              <MapPin size={16} color="#17C3CE" style={{ flexShrink: 0, marginTop: "2px" }} />
              <span style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.9rem", lineHeight: 1.6 }}>
                Via Curio Dentato 9<br />
                (area commerciale Aliante)<br />
                02100 Rieti (RI)
              </span>
            </div>
          </div>

          {/* Recapiti */}
          <div>
            <h4 style={{
              color: "white", fontWeight: 600, marginBottom: "1.2rem",
              textTransform: "uppercase", letterSpacing: "0.06em", fontSize: "0.8rem"
            }}>
              RECAPITI
            </h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
              <a
                href="tel:+393463785564"
                style={{
                  display: "flex", alignItems: "center", gap: "0.6rem",
                  color: "rgba(255,255,255,0.7)", textDecoration: "none",
                  fontSize: "0.9rem", transition: "color 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = "#17C3CE"}
                onMouseLeave={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.7)"}>

                <Phone size={16} color="#17C3CE" />
                +39 3463785564
              </a>
              <a
                href="mailto:washsofa1@gmail.com"
                style={{
                  display: "flex", alignItems: "center", gap: "0.6rem",
                  color: "rgba(255,255,255,0.7)", textDecoration: "none",
                  fontSize: "0.9rem", transition: "color 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = "#17C3CE"}
                onMouseLeave={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.7)"}>

                <Mail size={16} color="#17C3CE" />
                washsofa1@gmail.com
              </a>
              <a
                href="https://wa.me/393463785564"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex", alignItems: "center", gap: "0.6rem",
                  color: "rgba(255,255,255,0.7)", textDecoration: "none",
                  fontSize: "0.9rem", transition: "color 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = "#25D366"}
                onMouseLeave={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.7)"}>

                <svg width="16" height="16" viewBox="0 0 32 32" fill="#25D366">
                  <path d="M16.003 0C7.17 0 .003 7.163.003 15.997c0 2.824.74 5.566 2.143 7.976L0 32l8.246-2.11A15.957 15.957 0 0016.003 32C24.836 32 32 24.837 32 16.003 32 7.167 24.836 0 16.003 0zm7.27 21.073c-.4-.198-2.36-1.16-2.726-1.29-.366-.133-.633-.198-.9.2-.265.4-1.03 1.29-1.263 1.558-.232.265-.465.298-.864.1-.4-.198-1.686-.62-3.21-1.974-1.186-1.055-1.988-2.36-2.22-2.757-.233-.4-.025-.614.174-.813.18-.178.4-.465.6-.698.198-.233.264-.4.397-.665.132-.265.066-.498-.033-.697-.1-.198-.9-2.163-1.233-2.96-.324-.78-.653-.674-.9-.686l-.764-.013c-.265 0-.697.1-1.063.498-.366.4-1.397 1.364-1.397 3.327 0 1.963 1.43 3.86 1.63 4.127.197.265 2.814 4.297 6.818 6.026.954.41 1.697.655 2.277.837.957.304 1.828.261 2.516.158.767-.114 2.36-.963 2.693-1.893.332-.93.332-1.727.232-1.893-.1-.166-.366-.265-.764-.465z" />
                </svg>
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          style={{
            borderTop: "1px solid rgba(255,255,255,0.1)",
            paddingTop: "1.5rem",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "0.5rem"
          }}>

          <p style={{ color: "rgba(255,255,255,0.45)", fontSize: "0.82rem", margin: 0 }}>
            © {new Date().getFullYear()} WashSofà – P.IVA 01263280578. Tutti i diritti riservati. Sito sviluppato da{" "}
            <a
              href="https://ideamedia.org"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "rgba(255,255,255,0.55)", textDecoration: "underline" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#17C3CE")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.55)")}
            >
              IdeaMedia agenzia web
            </a>
          </p>
          <div style={{ display: "flex", gap: "1.2rem" }}>
            {["Privacy Policy", "Cookie Policy", "Note Legali"].map((label) =>
            <span
              key={label}
              style={{ color: "rgba(255,255,255,0.45)", fontSize: "0.82rem", cursor: "default" }}>

                {label}
              </span>
            )}
          </div>
        </div>
      </div>
    </footer>);

}